"use client";

import { ConnectButton } from "@rainbow-me/rainbowkit";

export function GameWalletConnect() {
  return (
    <div className="flex justify-center">
      <ConnectButton
        label="Connect Wallet to Play"
        showBalance={false}
      />
    </div>
  );
}
